<template>
  <div class="elements-for-engraving">
    <div class="elements">

      <button
        @click="setActiveElementForEngraving(item.element_id)"
        class="elements__item"
        :class="{'selected': activeElementId&&activeElementId==item.element_id}"
        v-for="item in elements"
        :key="`efe-${item.element_id}`"
      >
        <PopupTitle :titleText="item.article">
          <span
            class="image"
            :style="{backgroundImage: `url(${item.image})`}"
          ></span>
        </PopupTitle>
      </button>

    </div>

  </div>
</template>
<script>
export default {
  name: "ElementsForEngraving",
  props: {
    elements: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    setActiveElementForEngraving(elementId) {
      this.$store.dispatch(
        "ClientEngravingSettings/setActiveElementId",
        elementId
      );
    },
  },
  computed: {
    activeElementId() {
      return this.$store.state.ClientEngravingSettings.activeElementId;
    },
  },
};
</script>
<style scoped>
.elements-for-engraving {
  display: flex;
  position: absolute;
  top: 50px;
  left: 0;
  bottom: 0;
  z-index: 1;
  width: 103px;
  border-left: 1px #c9dde6 solid;
  transition: all 0.2s;
  background-color: #fff;
}
.elements {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.elements__item {
  padding: 10px;
  display: grid;
  place-items: center;
}
.elements__item:hover .popup_title {
  z-index: 2;
}

.elements__item + .elements__item {
  border-top: 1px #c9dde6 solid;
}

.image {
  display: block;
  width: 78px;
  height: 78px;
  border: 2px #c9dde6 solid;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
}

.elements__item.selected .image {
  border: 2px solid #10b981;
}

@media screen and (max-width: 1000px) {
  .elements-for-engraving {
    top: 32px;
    width: 50px;
    bottom: 40px;
  }
  .elements-for-engraving .elements__item {
    padding: 5px;
  }
  .elements-for-engraving .elements__item .image {
    width: 38px;
    height: 38px;
    border-width: 1px;
  }
}
</style>
